const DataTableElement = ({ formatter, element = void 0, index = void 0 }) => formatter(element, index);
export default DataTableElement;
